import React, {useState} from 'react';
import Modal from 'react-modal';
import classnames from 'classnames';
import ButtonCommon from '../../../common/components/ButtonCommon';
import styles from './styles.module.scss';

const ModalCommon = ({
                       header,
                       children,
                       openButtonLabel,
                       closeButtonLabel = 'סגירה',
                       handleAction,
                       handleClose,
                       getDataOnOpenModal,
                       disableActionButton,
                       customModalTrigger = null,
                       customTriggerModal = false,
                       classNameTriggerContainer = '',
                       size = 'lg',
                       customActionButton
                     }) => {
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    if (!customTriggerModal) {
      setShowModal(true);
      if (getDataOnOpenModal) {
        getDataOnOpenModal();
      }
    } else {
      customTriggerModal.handleShow();
    }
  };
  const handleCloseModal = () => {
    if (!customTriggerModal) {
      setShowModal(false);
    } else {
      customTriggerModal.handleHide();
    }

    if (handleClose) handleClose();
  };

  return (
    <>
      {customModalTrigger
        ? (
          <div className={classnames(styles.triggerContainer, classNameTriggerContainer)}
               onClick={() => handleShowModal()}>
            {customModalTrigger}
          </div>
        )
        : (
          <ButtonCommon
            label={openButtonLabel}
            onClick={() => handleShowModal()}
            customContainerStyles={styles.buttonOpen}
          />
        )
      }

      <Modal
        isOpen={!customTriggerModal ? showModal : customTriggerModal.show}
        onRequestClose={handleCloseModal}
        className={styles.modal}
        overlayClassName={styles.overlay}
      >
        <div className={classnames(
          styles.modalContainer,
          size === 'xl' && styles.xlSize,
          size === 'md' && styles.mdSize,
        )} dir="rtl">
          <h2 className={styles.modalHeader}>{header}</h2>
          {children}
          <div className={styles.buttonsContainer}>
            <ButtonCommon
              label={closeButtonLabel}
              onClick={handleCloseModal}
              customContainerStyles={styles.buttonCancelContainer}
              customLabelStyles={styles.buttonCancelLabel}
            />
            {customActionButton || handleAction && (
              <ButtonCommon
                label={'עריכה'}
                onClick={() => {
                  handleCloseModal();
                  handleAction();
                }}
                customContainerStyles={styles.buttonActionContainer}
                disabled={disableActionButton}
              />
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalCommon;